/* predator-lander-fix5.js
   STORE-LOVABLE-1, 2026-09-05.

   ONE defect, measured on the live PDP, in one place.

   Bon: "lovable theme claim dual dovetail bridge animation to add the thing to
   section 20 cards after u click it and also the ability to unclaim when u
   unclick it doesnt work anymore".

   THE BUG. predator-lander.js binds the six CLAIM surfaces like this:

       val === "pill" || val === "s16-au" ? k.toggleBridge() : k.setBridge(!0)

   So the small pills and the section 16 auto badge TOGGLE, but the two big
   buttons, data-no-val "s16-row" (section 16 IN THE BOX) and "buy-row"
   (section 20 BUY BOX), call setBridge(true) unconditionally. They can claim
   and they can never unclaim. Measured on the live page today: pressing either
   one while claimed leaves state.bridge true, so the button reads CLAIMED
   forever and the customer cannot drop the bridge from that surface.

   That also has a cart consequence, because the live predator-kit.js includes
   PRED-BRIDGE in the cart payload from that same flag:
       state.bridge && out.push({id: VARIANTS.bridge, quantity: 1})
   so a customer who wants the kit without the free bridge line cannot get there
   from the two most prominent buttons on the page.

   THE FIX. Rebind those two buttons only, in the capture phase, so the base
   file's one way handler never runs for them, and call the engine's own
   toggleBridge instead. Everything else on the page is left completely alone:
   the pills, the checkboxes, the animation, the CLAIMED chrome, the kit
   selector sync and the cart payload are all already correct and all keep
   working, because they are all driven by the same engine flag this now flips.

   ADDITIVE. It does not modify predator-lander.js, predator-lander-fix3.js,
   predator-lander-fix4.js or predator-kit.js.

   No em or en dashes anywhere in this file.
*/
(function () {
  "use strict";

  var root = document.getElementById("no-predator");
  if (!root || root.hasAttribute("data-no-fix5")) return;
  root.setAttribute("data-no-fix5", "1");

  /* Only the two surfaces the base file wired one way. The other four already
     toggle, and rebinding them would just undo a working control. */
  var ONE_WAY = { "s16-row": 1, "buy-row": 1 };

  function bind() {
    var k = window.NOPredatorKit;
    if (!k || typeof k.toggleBridge !== "function") return false;

    var n = 0;
    var all = root.querySelectorAll('[data-no="claim-free"]');
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      var val = b.getAttribute("data-no-val") || "";
      if (!ONE_WAY[val]) continue;
      if (b.hasAttribute("data-no-fix5-claim")) continue;
      b.setAttribute("data-no-fix5-claim", "1");
      /* Capture phase plus stopImmediatePropagation: the base file's listener is
         on the same element in the bubble phase, so this runs first and stops it
         from also firing setBridge(true) straight back on. */
      b.addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        window.NOPredatorKit.toggleBridge();
      }, true);
      n++;
    }
    return n > 0;
  }

  /* The engine and the lander both boot from their own deferred scripts, and the
     theme can re-render the product info section. Try until the engine exists,
     then keep an eye on section reloads. The data-no-fix5-claim guard makes
     every extra call a no op. */
  if (!bind()) {
    var tries = 0;
    var t = setInterval(function () {
      if (bind() || ++tries > 100) clearInterval(t);
    }, 100);
  }
  document.addEventListener("shopify:section:load", function () { bind(); });

  window.NOPredatorFix5 = { rebind: bind, oneWay: ONE_WAY };
})();
